import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_CLINICAL_PRODUCT_CATEGORY_COLLECTION_NAME =
  "clinical-product-category";

export const useRxCollectionClinicalProductCategory =
  (): RxCollection<ClinicalProductCategory> | null =>
    useRxCollection<ClinicalProductCategory>(
      RXDB_CLINICAL_PRODUCT_CATEGORY_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<ClinicalProductCategory>>;
export type ClinicalProductCategoryQueryConstructor = UseRxData["1"];

const CLINICAL_PRODUCT_CATEGORY_SCHEMA_LITERAL = {
  title: "clinical product category schema",
  version: 1,
  description: "Represents a Clinical Product Category",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    title: {
      type: "object",
      properties: {
        en: { type: "string" },
      },
      required: ["en"],
    },
  },
  required: ["id", "meta", "title"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(
  CLINICAL_PRODUCT_CATEGORY_SCHEMA_LITERAL,
);

export type ClinicalProductCategory = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const CLINICAL_PRODUCT_CATEGORY_SCHEMA: RxJsonSchema<ClinicalProductCategory> =
  CLINICAL_PRODUCT_CATEGORY_SCHEMA_LITERAL;
